import _ from "lodash"
import {Error, Errors} from "mixins/FormTypes"

class FormErrors<FormErrorsType> {
  constructor(public errors: Errors = {}) {
  }

  /**
   * Determine if the collection has any errors.
   */
  hasErrors = () => {
    return !_.isEmpty(this.errors)
  }


  /**
   * Determine if the collection has errors for a given field.
   */
  has = (field: string) => {
    return _.indexOf(_.keys(this.errors), field) > -1
  }

  /**
   * Get all of the raw errors for the collection.
   */
  all = () => {
    return this.errors
  }


  /**
   * Get all of the errors for the collection in a flat array.
   */
  flatten = () => {
    return _.flatten(_.toArray(this.errors))
  }


  /**
   * Get the first error message for a given field.
   */
  get = (error: Error) => {
    if (this.has(error)) {
      return this.errors[error][0]
    }
  }


  /**
   * Set the raw errors for the collection.
   */
  set = (errors: Errors) => {
    if (typeof errors === 'object') {
      this.errors = errors
    } else {
      this.errors = {'form': 'Something went wrong. Please try again or contact customer support.'}
    }
  }


  /**
   * Remove errors from the collection.
   */
  forget = () => {
    this.errors = {}
  }
}

export default FormErrors
